export default __webpack_public_path__ + "static/media/ser7.aea353b9.svg";